import { IDataTh, ThCoreIndex } from "src/Pages/components";

export const THeadFiliais = () => {
  const dataTh: IDataTh[] = [
    {
      title: "Ações",
      width: "40px",
      align: "left",
    },
    {
      title: "Filiais",
      align: "left",
    },
  ];

  return <ThCoreIndex dataTh={dataTh} />;
};
